import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { TreeListItem } from "../../Common/TreeList/Index";
import { ITreeListItem } from "../../Common/TreeList/Helper/Types";
import { IRootState } from "../../../reducer/CombineReducer";
import { IExtractList } from "./redux/Types";
import { ExtractListSlice } from ".";

interface IExtractTreeListItem {
  item: IExtractList;
  handleOnClickItem: (item: IExtractList) => void;
}

/**
 * Responsible for rendering the Extract Tree List Items
 */
export const ExtractTreeListItem: React.FC<IExtractTreeListItem> = (props: IExtractTreeListItem) => {

  const { item, handleOnClickItem } = props;
  const extractState = useSelector((state: IRootState) => state.extractState);
  const dispatch = useDispatch();

  const listItemData: ITreeListItem = {
    id: item.extractGuid,
    displayText: item.extractName,
    hasNodes: false,
    level: 0,
    isOpen: false
  };

  const refreshDetailTab = (extractItem: IExtractList): void => {
    dispatch(ExtractListSlice.actions.selectedExtract(extractItem));
  };

  const onClickItem = (): void => {
    handleOnClickItem(item);
  };

  const onClickDetail = (): void =>{
    refreshDetailTab(item);
  };

  return (
    <>
      <TreeListItem
        item={listItemData}
        selected={extractState.selectedExtract?.extractGuid === item.extractGuid}
        handleOnClick={onClickItem}
        handleOnClickTrailing = {onClickDetail}
      />
    </>
  );
};

export default ExtractTreeListItem;
